import { useState } from 'react';
import {
  RECENT_SEARCH_RESULTS_LIMIT,
  RECENT_SEARCHES_STORAGE_KEY,
} from '#/shared/constants';
import { storeItem, getItem } from '#/shared/utils/storage';

export default () => {
  const [recentSearches, setRecentSearches] = useState(
    getItem(RECENT_SEARCHES_STORAGE_KEY, [])
  );
  const addRecentSearch = ({ location }) => {
    // Filter out the result if it's already been searched and stack back on top
    const filteredResults = recentSearches.filter(
      s => s.name !== location.name
    );
    const newRecentSearches = [location, ...filteredResults].slice(
      0,
      RECENT_SEARCH_RESULTS_LIMIT
    );
    storeItem(RECENT_SEARCHES_STORAGE_KEY, newRecentSearches);
    setRecentSearches(newRecentSearches);
  };

  return { recentSearches, addRecentSearch };
};
